import { render, staticRenderFns } from "./PurchaseReceivesList.vue?vue&type=template&id=26b74cf5&scoped=true&"
import script from "./PurchaseReceivesList.vue?vue&type=script&lang=js&"
export * from "./PurchaseReceivesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b74cf5",
  null
  
)

export default component.exports